<template>
   <b-modal
    ref="modal"
    title="Huỷ hoá đơn điện tử"
    header-bg-variant="danger"
    header-text-variant="white"
    @ok="handleSubmit"
    ok-title="Xác nhận huỷ"
    ok-variant="danger"
    cancel-title="Đóng"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    size="md"
    > <template v-if="invoice"
      > <!-- Invoice summary -->
      <div class="alert alert-light-danger border-danger mb-4">

        <div class="d-flex align-items-center mb-2">
           <i class="fas fa-exclamation-triangle text-danger mr-2"></i> <strong
            >Lưu ý quan trọng</strong
          >
        </div>

        <p
          class="mb-1 text-dark"
          style="font-size: 0.85rem"
        >
           Sau khi huỷ hoá đơn trên hệ thống, bạn <strong>bắt buộc</strong> phải lập <strong
            >Thông báo sai sót</strong
          > trên portal FAST/cơ quan thuế. Nếu không lập sẽ bị phạt khi kiểm toán.
        </p>

      </div>
       <!-- Invoice info --> <b-row class="mb-3"
        > <b-col md="6"
          > <label class="font-weight-bold mb-1">Số hoá đơn</label>
          <p>{{ invoice.invoiceNo || '---' }}</p>
           </b-col
        > <b-col md="6"
          > <label class="font-weight-bold mb-1">Ngày hoá đơn</label>
          <p>{{ formatInvoiceDateShort(invoice.invoiceDate) }}</p>
           </b-col
        > </b-row
      > <!-- Cancel form --> <b-form-group
        label="Lý do huỷ *"
        label-class="font-weight-bold"
        :invalid-feedback="reasonError"
        :state="reasonState"
        > <b-form-textarea
          v-model="form.reason"
          rows="3"
          placeholder="Nhập lý do huỷ hoá đơn..."
          :state="reasonState"
          @input="$v.form.reason.$touch()"
        ></b-form-textarea
        > </b-form-group
      > <!-- B2B-only: Minute info --> <template v-if="invoice.saleType === 'WHOLESALE'"
        > <b-row
          > <b-col md="6"
            > <b-form-group
              label="Số biên bản"
              label-class="font-weight-bold"
              > <b-form-input
                v-model="form.minuteNo"
                size="sm"
                placeholder="Số biên bản huỷ"
              ></b-form-input
              > </b-form-group
            > </b-col
          > <b-col md="6"
            > <b-form-group
              label="Ngày biên bản"
              label-class="font-weight-bold"
              > <date-picker
                v-model="form.minuteDate"
                format="dd/MM/yyyy"
                input-class="form-control form-control-sm"
                :bootstrap-styling="true"
              ></date-picker
              > </b-form-group
            > </b-col
          > </b-row
        > </template
      > </template
    > <!-- Loading overlay --> <loading-overlay
      :active="isSubmitting"
      :is-full-page="false"
      > <template #default
        >
        <div class="text-center">
           <b-spinner variant="danger"></b-spinner>
          <p class="mt-2 text-muted">Đang huỷ hoá đơn...</p>

        </div>
         </template
      > </loading-overlay
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  import DatePicker from 'vuejs-datepicker'
  import moment from 'moment'
  import LoadingOverlay from '@/view/components/common/LoadingOverlay.vue'
  import { EINVOICE_CANCEL } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { getToastInstance } from '@/utils/toastHelper'
  import einvoiceMixin from '../mixins/einvoice.mixin'

  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  export default {
    name: 'EInvoiceCancelModal',
    components: { DatePicker, LoadingOverlay },
    mixins: [validationMixin, einvoiceMixin],
    props: {
      invoice: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isSubmitting: false,
        form: {
          reason: '',
          minuteNo: '',
          minuteDate: null,
        },
      }
    },
    validations: {
      form: {
        reason: { required, minLength: minLength(5) },
      },
    },
    computed: {
      reasonState() {
        const { $dirty, $error } = this.$v.form.reason
        return $dirty ? !$error : null
      },
      reasonError() {
        if (!this.$v.form.reason.required) return 'Vui lòng nhập lý do huỷ'
        if (!this.$v.form.reason.minLength) return 'Lý do phải có ít nhất 5 ký tự'
        return ''
      },
    },
    methods: {
      show() {
        this.resetForm()
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      resetForm() {
        this.form = {
          reason: '',
          minuteNo: '',
          minuteDate: null,
        }
        this.$v.$reset()
      },
      async handleSubmit(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.form.$touch()
        if (this.$v.form.$invalid) return

        this.isSubmitting = true
        try {
          await this.$store.dispatch(EINVOICE_CANCEL, {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            reason: this.form.reason,
            minuteNo: this.form.minuteNo || undefined,
            minuteDate: this.form.minuteDate
              ? moment(this.form.minuteDate).format('YYYYMMDD')
              : undefined,
          })
          makeToastSuccess('Huỷ hoá đơn thành công')
          this.$emit('canceled')
          this.hide()
        } catch (err) {
          const msg = err?.message || 'Huỷ hoá đơn thất bại'
          makeToastFailure(msg)
        } finally {
          this.isSubmitting = false
        }
      },
    },
  }
</script>

